import { OnInit, Optional, Inject, Component } from '@angular/core';
import { DomainContext, IAuthorizationService, IContextService, PershingTranslationService } from '@pershing/pershing-core';
import { Loans, Mortgages } from '@pershing/nxi-ng-balances/lib/model';
import { NxiContextUtils } from '@pershing/nxi-common';
import { BlanceKeyRestService } from '../../services/NXI-Balances.services';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { ActivatedRoute } from '@angular/router';
export enum ToggleEnum {
    investments,
    loans
  }
@Component({
    selector: 'balances-toggle-wrapper',
    templateUrl: './balances-toggle-wrapper.component.html'
})
export class BalancestoggleWrapperComponent implements OnInit {
    mortgagesData: Mortgages;
    loansData: Loans;
    loanAdvanceData: any;
    loanAdvanceSummary: any;
    displayContainer: any;
    loanAdvdata: any
    displayToggle: boolean = false;
    mobiletoggle: any;
    isLoading: boolean = true;
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    subs1: Subscription;
    acctRef: string;
    acctRegTypeCode: string;
    roleStore: any;
    entitledForLiabilities: boolean = false;
    nplAccount: string = 'NPL';
    nplFlag: boolean = false;
    allAccountsCheck: any;
    groupAccount: any;
    isTabletTheme: boolean = false;
    isAdaTheme: boolean = false;
    displayLoanAdvance: boolean = false;
    displayLoanSummary: boolean = false;
    toggleEnum = ToggleEnum;
    selectedState: any;
    acctReg: string = '';
    liabilitiesData: any;
    loanSumData: any;
    displayLoanMortgage: boolean = false;
    
    constructor(
        private translationService: PershingTranslationService,
        private balanceRestService: BlanceKeyRestService,
        private contextService: IContextService,
        private authorizationService: IAuthorizationService,
        private nxiRestService: NxiRestService,
        private route: ActivatedRoute,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        if (appSettings.deviceType && appSettings.deviceType === 'tablet') {
            this.isTabletTheme = true;
        }
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.isAdaTheme = true;
        }
    }

    ngOnInit() {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        this.roleStore = this.authorizationService['roleStore'] !== null;
        this.entitledForLiabilities = this.roleStore && this.authorizationService.isEntitled('LIABILITIES_BALANCE') ?
            this.authorizationService.isEntitled('LIABILITIES_BALANCE') : true;
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
           this.acctRegTypeCode = domainContext.value.accessCategoryCd;
           this.allAccountsCheck = domainContext.value.accountNumber;
           this.groupAccount = domainContext.domain;
           if(this.acctRegTypeCode !== '' && this.acctRegTypeCode !== undefined && this.acctRegTypeCode != null) {
                this.acctReg = this.acctRegTypeCode.substring(0,3);
           } else {
                this.acctReg = '';
           }
           this.displayToggle = false;
            if(this.nplAccount === this.acctReg || this.route.snapshot.queryParams.nplFlag == 'true') {
            this.getLoanAdvanceSummary();
            this.nplFlag = true;
            } else {
                this.getLoanAdvance();
                this.nplFlag = false;
            }  
            if (this.entitledForLiabilities) {
                this.getUserLiabilities();
            }
        });
        
    }

    getUserLiabilities() {
        this.balanceRestService.getLiabilities().subscribe(resp => {
            this.liabilitiesData = resp;
            if (!!this.liabilitiesData) {
                this.mortgagesData = this.liabilitiesData.mortgages;
                this.loansData = this.liabilitiesData.loans;
                if (this.liabilitiesData.returnCode === 'SUCCESS') {
                    this.displayLoanMortgage = true;
                    if (!this.isAdaTheme) {
                        this.displayToggle = true;
                       if (!this.nplFlag) {
                        if (this.route.snapshot.queryParams.expandLiabilities == 'M' || this.route.snapshot.queryParams.expandLiabilities == 'L') {
                            this.selectedState = this.toggleEnum.loans;
                             this.displayContainer = 'loans';
                        } else {
                            this.selectedState = this.toggleEnum.investments;
                            this.displayContainer = 'investments';
                        }
                        } else {
                            this.selectedState = this.toggleEnum.loans;
                        this.displayContainer = 'loans';
                        }
                    } 
                } else {
                    this.displayLoanMortgage = false;   
                }
            }
            this.isLoading = false;
        });
    }
    getLoanAdvanceSummary() {
        if (this.acctRef !== '' && this.acctRef !== undefined) {
            this.nxiRestService.getNxiPortfolioRestResponse(this.acctRef, 'loanAdvanceSummary').subscribe(resp => {
                this.loanSumData = resp;
                    this.loanAdvanceSummary = this.loanSumData; // based on npl account we have show the data till  get response from that we can get the logic
                    if (this.loanSumData.hostReturnCode == 0 || this.loanSumData.hostReturnCode === '00') {
                        this.displayLoanSummary = true;
                        this.displayLoanAdvance = false;
                        if (!this.isAdaTheme) {
                            this.displayToggle = true;
                            if (this.nplFlag) {
                                this.selectedState = this.toggleEnum.loans;
                                this.displayContainer = 'loans';
                                }
                        } 
                    } else {
                        this.displayLoanSummary = false;
                     }
                this.isLoading = false;
            });
        }
    }
    getLoanAdvance() {
        if (this.acctRef !== '' && this.acctRef !== undefined) {
           this.subs1 = this.nxiRestService.getNxiPortfolioRestResponse(this.acctRef, 'loanAdvance').subscribe(resp => {
                this.loanAdvdata = resp;
                    this.loanAdvanceData = this.loanAdvdata.noofActiveLoans_RepeatingBlock; // based on npl account we have show the data till  get response from that we can get the logic
                    if (this.loanAdvdata.hostReturnCode == 0 || this.loanAdvdata.hostReturnCode === '00') {
                        this.displayLoanAdvance = true
                        this.displayLoanSummary = false;
                        if(!this.isAdaTheme) {
                            this.displayToggle = true;
                           if (!this.nplFlag) {
                            this.selectedState = this.toggleEnum.investments;
                            this.displayContainer = 'investments';
                            }
                        } 
                    } else {
                        this.displayLoanAdvance = false;
                    }
                this.isLoading = false;
            });
        }
    }
    toggleView($event: any) {
      this.selectedState = $event.value;
      if (this.selectedState == 0) {
        this.displayContainer = 'investments';
    } else {
        this.displayContainer = 'loans';
    }
    }
}
